// import { convertNumberToWords } from "../../../../../utils/common";

// const SubTotal = ({ data, isInventory = false }) => {
 
//   return (
//     <div className="flex flex-col gap-4 font-medium">
//       <div className="flex flex-col gap-2 items-end border-b pb-4">
//         {/* Subtotal */}
//         <div className="flex items-center gap-2">
//           <span className="text-gray-600">Subtotal:</span>
//           <span className="text-theme font-bold">
//             {isInventory
//               ? parseFloat(data?.sub_total || 0.0).toFixed(2)
//               : (
//                   parseFloat(data?.items_amount || 0) -
//                   parseFloat(data?.total_items_tax || 0)
//                 ).toFixed(2) || 0.0}
//             /-
//           </span>
//         </div>
//         {/* Tax */}
//         {!data?.hideTex && (
//           <div className="flex items-center gap-2">
//             <span className="text-gray-600">Total Tax :</span>
//             <span className="text-theme font-bold">
//               {isInventory
//                 ? data?.tax || 0.0
//                 : parseFloat(data?.total_items_tax || 0.0).toFixed(2)}
//               /-
//             </span>
//           </div>
//         )}

//         {/* Total with Tax */}
//         <div className="flex items-center gap-2">
//           <span className="text-gray-600">Total:</span>
//           <span className="text-theme font-bold">
//             {isInventory
//               ? data?.total_amount || 0.0
//               : parseFloat(data?.items_amount || 0.0).toFixed(2)}
//             /-
//           </span>
//         </div>
//       </div>

//       {/* Amount in Words */}
//       <div>
//         <span>
//           Amount in Words:{" "}
//           <b>{convertNumberToWords(data?.items_amount || 0.0)}</b>
//         </span>
//       </div>
//     </div>
//   );
// };

// export default SubTotal;


import { convertNumberToWords } from "../../../../../utils/common";

const SubTotal = ({ data, isInventory = false }) => {
  // ✅ Calculate Total
  const total = isInventory
    ? parseFloat(data?.total_amount || 0.0)
    : parseFloat(data?.items_amount || 0.0);

  return (
    <div className="flex flex-col gap-4 font-medium">
      <div className="flex flex-col gap-2 items-end border-b pb-4">
        {/* Subtotal */}
        <div className="flex items-center gap-2">
          <span className="text-gray-600">Subtotal:</span>
          <span className="text-theme font-bold">
            {isInventory
              ? parseFloat(data?.sub_total || 0.0).toFixed(2)
              : (
                  parseFloat(data?.items_amount || 0) -
                  parseFloat(data?.total_items_tax || 0)
                ).toFixed(2) || 0.0}
            /-
          </span>
        </div>

        {/* Tax */}
        {!data?.hideTex && (
          <div className="flex items-center gap-2">
            <span className="text-gray-600">Total Tax :</span>
            <span className="text-theme font-bold">
              {isInventory
                ? data?.tax || 0.0
                : parseFloat(data?.total_items_tax || 0.0).toFixed(2)}
              /-
            </span>
          </div>
        )}

        {/* Total with Tax */}
        <div className="flex items-center gap-2">
          <span className="text-gray-600">Total:</span>
          <span className="text-theme font-bold">{total.toFixed(2)}/-</span>
        </div>
      </div>

      {/* Amount in Words */}
      <div>
        <span>
          Amount in Words: <b>{convertNumberToWords(total)}</b>
        </span>
      </div>
    </div>
  );
};

export default SubTotal;
